export const NOTE_TAG_ALIAS = {
  OFFER_NOTE: 'Offer',
};
